import React from 'react';
import Icone from '../util/Icone';
import { faArrowRight } from '../util/icones';
import imagem3 from "../../assets/3.webp";

const Automation = () => {
  return (
    <section className="grid xl:grid-cols-[5fr_3fr] xl:items-center xl:pt-24 pb-12 mb-4">
      <div className="xl:col-start-2 xl:row-start-1 xl:self-end z-10">
        <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4">Automação</p>
        <h3 className="text-2xl xl:text-4xl font-semibold leading-tight mb-6">
          O trabalho repetitivo acontece sozinho
        </h3>
      </div>

      <div className="xl:col-start-1 xl:row-start-1 xl:row-span-2 xl:self-center flex justify-center xl:justify-start mb-10 xl:mb-0">
        <img
          src={imagem3}
          alt="Notebook flutuando sobre um fundo azul. Na tela, um sistema com os registros organizados automaticamente."
          width="500"
          height="500"
          loading="lazy"
          className="max-w-full h-auto aspect-square"
        />
      </div>

      <div className="xl:col-start-2 xl:row-start-2 xl:self-start z-10">
        <p className="text-xl leading-relaxed">
          Conectamos qualquer sistema, planilha, e-mail ou ferramenta que a sua empresa já usa, para que o trabalho repetitivo aconteça sozinho: lançamentos, relatórios, avisos e o que mais precisar.
        </p>
        <a href="/automacao-de-processos" className="inline-flex items-center gap-2 font-semibold text-pattern-dark hover:underline mt-6">
          O que dá para automatizar
          <Icone icon={faArrowRight} className="text-sm" />
        </a>
      </div>
    </section>
  );
};

export default Automation;
